/** Non-error status banner. Keep `role="status"` for existing tests. */
export function NoticeBanner({ children }) {
  if (!children) return null;
  return (
    <section
      className="rounded-2xl border border-eorig-border border-l-4 border-l-eorig-cyan bg-white p-4 text-sm text-eorig-ink shadow-eorig-card"
      role="status"
    >
      {children}
    </section>
  );
}
